import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Card, CardContent } from '@mui/joy';
import DeleteIcon from '@mui/icons-material/Delete';
import Header from './Header';
import './AllFiles.css';
import { endpoint } from '../../resource/Constant';
const MyFiles = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    setLoading(true);
    try {
      const response = await fetch(endpoint + '/api/aichatbot/list_files', {
        method: 'GET',
        headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` }
      });
      const result = await response.json();

      if (!response.ok) throw new Error(result.detail || 'Failed to fetch files.');

      setFiles(
        result.files.map((file, index) => ({
          id: index + 1,
          name: file,
          description: 'Uploaded document'
        }))
      );
    } catch (err) {
      setError(err.message?.detail);
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (fileName) => {
    try {
      const response = await fetch(endpoint + `/api/aichatbot/delete_file?file_name=${encodeURIComponent(fileName)}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`
        }
      });

      if (!response.ok) throw new Error('Failed to delete file.');

      setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <Header />
      <Box className="box-container">
        <Typography level="h3" sx={{ mb: 2, fontWeight: 500 }}>
          My Files
        </Typography>

        {loading ? (
          <Typography>Loading files...</Typography>
        ) : error ? (
          <Typography color="danger">{error}</Typography>
        ) : files.length === 0 ? (
          <Typography>No files uploaded yet.</Typography>
        ) : (
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            {files.map((file) => (
              <Card key={file.id} variant="outlined" sx={{ width: '250px', textAlign: 'center', p: 2 }}>
                <CardContent>
                  <Box sx={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography level="body-md" sx={{ fontWeight: 'bold', fontSize: '14px', wordBreak: 'break-word' }}>
                      {file.name}
                    </Typography>
                  </Box>

                  <Typography level="body-sm" sx={{ color: 'gray', mb: 1 }}>
                    {file.description}
                  </Typography>

                  <Button
                    size="sm"
                    color="danger"
                    sx={{ mb: 1, mt: 2 }}
                    startDecorator={<DeleteIcon />}
                    onClick={() => handleDelete(file.name)}
                  >
                    Delete
                  </Button>
                </CardContent>
              </Card>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default MyFiles;
